import React from 'react';

import { Config, IDENTIFY } from '../../../config/src';

const dropMixpanelFields = function ({ payload, integration, next }) {
  const segmentPayLoad = payload;

  if (segmentPayLoad.obj.type === IDENTIFY) {
    try {
      delete segmentPayLoad.obj.traits.firstName;
      delete segmentPayLoad.obj.traits.lastName;
      delete segmentPayLoad.obj.traits.email;
      delete segmentPayLoad.obj.traits.phone;
      delete segmentPayLoad.obj.traits.avatar;
      delete segmentPayLoad.obj.traits.city;
      delete segmentPayLoad.obj.traits.gender;
    } catch (e) {
      console.error('Middleware error', e);
    }
  }
  next(segmentPayLoad);
};

export function loadSegmentScript() {
  const analytics = (window.analytics = window.analytics || []);
  let segmentScriptElement;
  if (!analytics.initialize) {
    if (analytics.invoked) {
      window.console &&
        console.error &&
        console.error('Segment snippet added and analytics initialized.');
    } else {
      analytics.invoked = !0;
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
        'addSourceMiddleware',
        'addIntegrationMiddleware',
        'setAnonymousId',
        'addDestinationMiddleware'
      ];
      analytics.factory = function (e) {
        return function () {
          const t = Array.prototype.slice.call(arguments);
          t.unshift(e);
          analytics.push(t);
          return analytics;
        };
      };
      for (let e = 0; e < analytics.methods.length; e++) {
        const key = analytics.methods[e];
        analytics[key] = analytics.factory(key);
      }
      analytics.load = (key, e) => {
        segmentScriptElement = document.createElement('script');
        segmentScriptElement.type = 'text/javascript';
        segmentScriptElement.async = !0;
        segmentScriptElement.src =
          'https://cdn.segment.com/analytics.js/v1/' +
          key +
          '/analytics.min.js';
        const n = document.getElementsByTagName('script')[0];
        n.parentNode && n.parentNode.insertBefore(segmentScriptElement, n);
        analytics._loadOptions = e;
      };

      analytics._writeKey = Config.SEGMENT_ANALYTIC_WRITE_KEY;
      analytics.SNIPPET_VERSION = '4.13.2';
      analytics.addDestinationMiddleware('Mixpanel', [dropMixpanelFields]);
      analytics.load(`${Config.SEGMENT_ANALYTIC_WRITE_KEY}`);
    }
  }
}
